import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; // eslint-disable-line

import LogoImage from "images/JMA_logo1.jpg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as XIcon } from "images/x-social-media-logo-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as InstagramIcon } from "images/instagram-icon.svg";

const Container = tw.div`relative bg-gray-900 text-gray-100 -mx-8 -mb-8 px-8`;
const Content = tw.div`max-w-screen-xl mx-auto pt-16 pb-8`;
const FiveColumns = tw.div`flex flex-wrap justify-between`;

const Column = tw.div`w-1/2 md:w-1/5 mb-8 md:mb-0 text-sm sm:text-base text-center md:text-left`;
const CompanyColumn = tw.div`text-center md:text-left mb-16 lg:mb-0 w-full lg:w-1/5`;

const ColumnHeading = tw.h5`font-bold uppercase`;

const LinkList = tw.ul`mt-4 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-100 pb-1 transition duration-300`;

const LogoContainer = tw.div`flex items-center justify-center lg:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black`;

const CompanyAddress = tw.p`mt-4 max-w-xs font-medium text-sm mx-auto lg:mx-0 lg:mr-4 leading-loose text-center lg:text-left`;

const SocialLinksContainer = tw.div`mt-4 text-center lg:text-left`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-500 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

const CopyrightAndCompanyInfoRow = tw.div`pb-0 text-sm font-normal flex flex-col sm:flex-row justify-between items-center`;
const CopyrightNotice = tw.div``;
const CompanyInfo = tw.div``;

const Divider = tw.div`my-8 border-b-2 border-gray-800`;

export default () => {
  return (
    <Container>
      <Content>
        <FiveColumns>
          <CompanyColumn>
            <LogoContainer>
              <LogoImg src={LogoImage} />
              <LogoText>JMA RDG</LogoText>
            </LogoContainer>
            <CompanyAddress>
              Kanekal Road, Rayadurg, Anantapur, Andhra Pradesh 515865
            </CompanyAddress>
            <SocialLinksContainer>
              <SocialLink
                href="https://www.facebook.com/jmardg/"
                target="_blank"
              >
                <FacebookIcon />
              </SocialLink>
              <SocialLink href="https://x.com/jmardg" target="_blank">
                <XIcon />
              </SocialLink>
              <SocialLink
                href="https://www.youtube.com/@JMARDG"
                target="_blank"
              >
                <YoutubeIcon />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/jamiamohammadiaarabia/"
                target="_blank"
              >
                <InstagramIcon />
              </SocialLink>
            </SocialLinksContainer>
          </CompanyColumn>
          <Column>
            <ColumnHeading>Quick Links</ColumnHeading>
            <LinkList>
              {/* <LinkListItem>
                <Link href="#">Registration</Link>
              </LinkListItem> */}
              <LinkListItem>
                <Link href="/magazine">Magazines</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/departments">Departments</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/about">About Us</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Jamia</ColumnHeading>
            <LinkList>
              {/* <LinkListItem>
                <Link href="/alumni">Alumni</Link>
              </LinkListItem> */}
              
              <LinkListItem>
                <Link href="\donation">Donations & Fees</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/events">Events</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Jamia</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/jmardg">Videos</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/about">About</Link>
              </LinkListItem>
              {/* <LinkListItem>
                <Link href="#">Login</Link>
              </LinkListItem> */}
              <LinkListItem>
                <Link href="#">Disclaimer</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Contact</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="tel:+919876543210">+91 8555-800743</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="tel:+917666861529">+91 7666-861529</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="mailto:jamiamohammadiaarabia1926@gmail.com">
                  jamiamohammadiaarabia1926@gmail.com
                </Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Rayadurg</Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </FiveColumns>
        <Divider />
        <CopyrightAndCompanyInfoRow>
          <CopyrightNotice>
            &copy; Copyright {new Date().getFullYear()}, Jamia Mohammadia Arabia
          </CopyrightNotice>
          <CompanyInfo>JMARDG All Rights Reserved.</CompanyInfo>
        </CopyrightAndCompanyInfoRow>
      </Content>
    </Container>
  );
};
